import { Container } from "../components/Container";
import { SectionHeading } from "../components/SectionHeading";
import styles from "./HowItWorks.module.css";

/**
 * The rules of the board, stated plainly.
 *
 * Every line here is canon, not marketing: review before listing (§ 2, § 3), bidding today
 * for tomorrow (§ 7), a won position held for the whole display day (§ 8), free rollover
 * into unused capacity (§ 9), and popularity earned by clicks rather than bought (§ 11).
 * A visitor who reads this section should be able to predict what the rest of the page
 * does — that is the point of publishing the mechanism instead of implying one.
 */
const STEPS = [
  {
    figure: "01",
    title: "A founder submits a deal",
    body: "Dealbid reviews the product, the seller's connection to it, the destination link and the advertised value before anything is listed. A nominal or misleading discount is not eligible, however much is bid for it.",
  },
  {
    figure: "02",
    title: "Approved deals bid today for tomorrow",
    body: "Each daily auction is independent and opens at $1. The highest qualifying bids take tomorrow's ten positions; an equal bid placed earlier ranks higher.",
  },
  {
    figure: "03",
    title: "Winners hold the board all day",
    body: "A won position is locked for the whole of the next display day and cannot be outbid during it. Where fewer than ten positions are won, previous deals fill the rest at no extra charge rather than leaving the board short.",
  },
  {
    figure: "04",
    title: "Buyers decide the weekly and monthly lists",
    body: "Those lists follow qualified buyer clicks over the calendar week and month. Bid amount plays no part in them, which is why the daily board and the earned lists can disagree.",
  },
];

export function HowItWorks() {
  return (
    <section className={styles.section} aria-labelledby="how-it-works">
      <Container>
        <SectionHeading
          id="how-it-works"
          title="How it works"
          description="Dealbid sells one thing: a day of placement on the board. It does not sell review outcomes, and it does not promise sales, leads or a number of impressions."
        />
        <ol className={styles.steps} role="list">
          {STEPS.map((step) => (
            <li key={step.figure} className={styles.step}>
              <p className={`${styles.figure} figure`} aria-hidden="true">
                {step.figure}
              </p>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepBody}>{step.body}</p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
